import React from "react";
import { useNavigate } from "react-router-dom";

interface ServiceCardProps {
  title: string;
  image: string;
  description: string;
}

export const ServiceCard: React.FC<ServiceCardProps> = ({ title, image, description }) => {
  const navigate = useNavigate();

  return (
    <div className="group flex h-full flex-col rounded-lg bg-white shadow-sm transition-transform duration-200 hover:-translate-y-1 hover:shadow-md">
      <img src={image} alt={title} className="h-40 w-full rounded-t-lg object-cover" />
      <div className="flex flex-1 flex-col p-4 md:p-6">
        <h3 className="text-lg font-semibold md:text-xl">{title}</h3>
        <p className="mt-2 flex-1 text-sm text-gray-600 md:text-base">{description}</p>
        <button
          onClick={() => navigate("/kontakt")}
          className="btn mt-4 self-end bg-softbeige"
        >
          Begär offert!
        </button>
      </div>
    </div>
  );
};
